import F84Game from "../Game";
import ArrayUtils from "../utils/ArrayUtils";
import Scene from "./Scene";

export default class ResizableScene extends Scene {
    protected _viewport: Phaser.GameObjects.Zone;
    public get viewport(): Phaser.GameObjects.Zone {
        return this._viewport;
    }

    private _sceneEvents: Phaser.Events.EventEmitter;
    private _onResizeInternal = new Array<() => void>();

    private static SHUTDOWN = "shutdown";

    init(..._args: any[]): void {
        this._sceneEvents = new Phaser.Events.EventEmitter();
        // this.setCameraScale();
        this.scale.on(Phaser.Scale.Events.RESIZE, this.resize, this);
        this.resize();
    }

    // private setCameraScale(): void {
    //     this.cameras.main.setOrigin(0);
    //     this.cameras.main.setZoom(this.game.quality.resolution);
    // }

    // screenToWorldPosition(x: number, y: number): Phaser.Math.Vector2 {
    //     return this.cameras.main.getWorldPoint(x, y);
    // }

    create(): void {
        this.game.events.emit(Phaser.Scenes.Events.CREATE, this);
        this.events.on(Phaser.Scenes.Events.SHUTDOWN, this.shutdown, this);

        if (!this.game.device.os.desktop) {
            this.input.on(Phaser.Input.Events.POINTER_UP, () => this.scale.startFullscreen());
        }
    }

    //Add callback to the resize event and calls it immediately
	addResize(onResize: () => void): void {
		this._onResizeInternal.push(onResize);
		onResize();
    }
    
    removeResize(onResize: () => void): void {
        ArrayUtils.remove(this._onResizeInternal, onResize);
    }

    onShutdown(fn: () => void, context?: any): void {
        this._sceneEvents.addListener(ResizableScene.SHUTDOWN, fn, context);
    }

    shutdown(): void {
        if (this._sceneEvents) this._sceneEvents.emit(ResizableScene.SHUTDOWN);

        this.scale.off(Phaser.Scale.Events.RESIZE, this.resize, this);
        this.events.off(Phaser.Scenes.Events.SHUTDOWN, this.shutdown, this);

        this._onResizeInternal = [];

        if (this._sceneEvents) this._sceneEvents.destroy();
        this._sceneEvents = null;
    }

    getState(): any {
        return null;
    }

    get zoomScale(): number {
        return Math.min(this.scale.zoom * F84Game.Instance.DevicePixelRatio, 1) * this.game.quality.resolution;
    }

    resize(): void {
        this.cameras.cameras.forEach((camera) => {
			camera.setZoom(this.zoomScale);
			camera.width = this.scale.gameSize.width / this.game.quality.resolution;
			camera.height = this.scale.gameSize.height / this.game.quality.resolution;
            camera.setOrigin(0, 0);
		});

        if (this._viewport != null) {
            this._viewport.destroy();
        }
        this._viewport = this.add.zone(
            this.scale.gameSize.width / 2 / this.game.quality.resolution,
            this.scale.gameSize.height / 2 / this.game.quality.resolution,
            this.scale.gameSize.width / this.game.quality.resolution,
            this.scale.gameSize.height / this.game.quality.resolution
        );

        for (const onResize of this._onResizeInternal) {
			onResize();
		}
    }
}
